import { put, call } from 'redux-saga/effects';

import { changePassRequest } from '@api/user';
import { history, vsuiteRoutes } from '@routes';
import { toastError, toastSuccess } from '@store/notifications';

export const handleChangePasswordSaga = function* ({ payload = {} }) {
  const {
    data: { password, email, token },
    setErrors,
    setSubmitting,
  } = payload;
  try {
    yield call(changePassRequest, { password, email, token });

    yield put(
      toastSuccess({
        message: {
          defaultMessage: 'Password changed successfully.',
          id: 'components.reset-password-form.response.success',
        },
      })
    );

    yield call(history.push, vsuiteRoutes.LOGIN.make());
  } catch (error) {
    const { fieldErrors, nonFieldErrors, hasNonFieldError, hasFieldError } = error.data || {};

    if (hasFieldError) {
      yield call(setErrors, fieldErrors);
    }

    yield put(
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Password change failed.',
              id: 'components.reset-password-form.response.failure',
            },
      })
    );

    yield call(setSubmitting, false);
  }
};
